import React from "react";
import { View } from '../../../components/templates/View';
import { CDEndpointProtection, CMEndpointProtection } from '../organisms';
import { useViewport } from "../../../hooks";

const EndpointProtection = () => {

    const { width } = useViewport();

    return(
        width > 850 ?
            <>
                <View children={ <CDEndpointProtection /> }/>
            </>
        :
            <>
                <View children={ <CMEndpointProtection/> }/>
            </>
    );
}

export default EndpointProtection;

